import ActionTypes from "./ActionTypes";

const getPaymentsList = (payload) => {
  return {
    type: ActionTypes.GET_PAYMENTS,
    payload: payload,
  };
};

const clearPaymentsList = () => {
  return {
    type: ActionTypes.CLEAR_PAYMENTS,
  };
}



export { getPaymentsList, clearPaymentsList };
